import { Flex, FlexProps } from '@blockanalitica/ui';
import { ReactNode, useMemo } from 'react';
import { NavLink as RouterNavLink } from 'react-router';
import styled, { css } from 'styled-components';
import NavDropdown from './NavDropdown';

export type NavigationRoute = {
  title: string;
  linkTo: string;
  icon?: ReactNode;
  end?: boolean;
  subRoutes?: NavigationRoute[];
};

export interface NavigationProps extends FlexProps {
  routes: NavigationRoute[];
}

const NavLink = styled(RouterNavLink)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  font-weight: 700;

  ${({ theme }) => css`
    gap: ${theme.space['2xs']};
    color: ${theme.colors.primary};
    font-size: ${theme.sizes['0']};

    &:hover {
      color: ${theme.colors.hype.textPrimaryHover};
    
  `}
`;

export default function Navigation({ routes }: NavigationProps) {
  const networkRoutes = useMemo(
    () =>
      routes.map((route) => ({
        ...route,
        linkTo: route.linkTo === '/' ? route.linkTo : `${route.linkTo}`
      })),
    [routes]
  );

  return (
    <Flex gap="m">
      {networkRoutes.map((route) => {
        if (route.subRoutes && route.subRoutes.length > 0) {
          return <NavDropdown route={route} key={route.title} />;
        } else {
          return (
            <NavLink key={route.linkTo} to={route.linkTo} end={route.end}>
              {route.title}
            </NavLink>
          );
        }
      })}
    </Flex>
  );
}
